// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "get-carriers";

export const carrierSchema = z.object({
  id: z.string(),
  companyName: z.string().nullable(),
  totalLoads: z.number().nullable(),
  dotNumber: z.string().nullable(),
  mcNumber: z.string().nullable(),
  address: z.string().nullable(),
  contactEmail: z.string().nullable(),
  contactPhone: z.string().nullable(),
});

export const getCarriersResponseSchema = z.array(carrierSchema);




export type Carrier = z.infer<typeof carrierSchema>;

export type GetCarriersResponse = z.infer<typeof getCarriersResponseSchema>;




// broker/get-carriers endpoint
export function getCarriers(
): Promise<GetCarriersResponse> {
  return requestHandler(
    "broker/get-carriers",
    undefined,
    getCarriersResponseSchema,
  );
}

